import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'

import Button from '@/checkout-instore-legacy/components/Commons/Elements/Button'

export default function NotifierLogoutMessage({ message, onClick }) {
  message =
    message ||
    'Seu login expirou e você precisará digitar o seu email e senha novamente'
  return (
    <div className="aspect-ratio--object z-999">
      <div className="aspect-ratio--object flex bg-black-80" />
      <div className="aspect-ratio--object flex items-center tc f3-ns white">
        <div className="flex-auto ph5 ph7-ns lh-copy">
          <div id="error-message" className="mb6 mb7-ns">
            {message}
          </div>
          <Button type="submit" size="lg" onClick={onClick}>
            <FormattedMessage id="logoutContinue" />
          </Button>
        </div>
      </div>
    </div>
  )
}

NotifierLogoutMessage.propTypes = {
  onClick: PropTypes.func,
  message: PropTypes.string,
}
